import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import { Redirect } from 'react-router'
import { css } from '@emotion/core'
import { BeatLoader } from 'react-spinners'
import styled from 'styled-components'
import get from 'lodash/get'
import set from 'lodash/set'
import find from 'lodash/find'
import { Button, Container, Row, Col, TabContent, TabPane } from 'reactstrap'
import {
  modalAction,
  authAction,
  leaveTypeAction,
  leaveRequestAction,
  clientMasterAction,
  departmentAction,
  compensateRequestAction,
} from './../../actions/'
import {
  modalSelector,
  authSelector,
  leaveTypeSelector,
  leaveRequestSelector,
  clientMasterSelector,
  departmentSelector,
  compensateRequestSelector,
} from './../../selectors'
import {
  createArrayOfInbox,
  searchRequestInbox,
  createArrayOfProjectSubmitRequest,
  createArrayOfTimesheetRequest,
} from '../../function'
import CustomModalMessage from '../../components/modal-message'
import Searchbar from '../../components/searchbar-inbox'
import withLayout from '../../helpers/withLayout'
import InboxTable from '../../components/table-inbox'
import { Leave, Compensate } from '../../components/leave-request'
import ProjectSubmitRequestDetail from '../../components/project-information/form/project-submit-request-detail'
import { TimesheetDetail } from '../../components/timesheet/form/timesheet-detail'
import { FONTS } from '../../constants'

class InboxPage extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    if (get(nextProps, 'getLeaveRequestsData.leaveRequests')
    && get(nextProps, 'getLeaveTypeData')
    && get(nextProps, 'getClientData')
    && get(nextProps, 'getDepartmentData')) {
      const inbox = get(nextProps, 'getLeaveRequestsData.inbox')
      const pendingInbox = get(nextProps, 'getLeaveRequestsData.pendingInbox')
      const users = get(nextProps, 'getLeaveRequestsData.users')
      const positions = get(nextProps, 'getLeaveRequestsData.positions')
      const companys = get(nextProps, 'getLeaveRequestsData.companys')
      const lobs = get(nextProps, 'getLeaveRequestsData.lobs')
      const compensate = get(nextProps, 'getLeaveRequestsData.compensates')
      const projectSubmitRequest = get(nextProps, 'getLeaveRequestsData.projectSubmitRequestInbox')
      const timesheetRequest = get(nextProps, 'getLeaveRequestsData.timesheetRequest')
      const approverUsers = get(nextProps, 'getLeaveRequestsData.approverUsers')
      const projects = get(nextProps, 'getLeaveRequestsData.projects')
      const leaveTypes = get(nextProps, 'getLeaveTypeData')
      const clients = get(nextProps, 'getClientData')
      const departments = get(nextProps, 'getDepartmentData')
      set(tempState, 'leaveTypes', leaveTypes)
      set(tempState, 'clients', clients)
      set(tempState, 'departments', departments)
      set(tempState, 'inbox', inbox)
      set(tempState, 'timesheetRequest', timesheetRequest)
      set(tempState, 'compensate', compensate)
      set(tempState, 'pendingInbox', pendingInbox)
      set(tempState, 'defaultInbox', inbox)
      set(tempState, 'lobs', lobs)
      set(tempState, 'companys', companys)
      set(tempState, 'positions', positions)
      set(tempState, 'users', users)
      set(tempState, 'approverUsers', approverUsers)
      set(tempState, 'projects', projects)
      set(tempState, 'myInbox', createArrayOfInbox(inbox, users, companys, lobs, positions, leaveTypes))
      set(tempState, 'myPendingInbox', createArrayOfInbox(pendingInbox, users, companys, lobs, positions, leaveTypes))
      const compensateRequests = createArrayOfInbox(
        compensate, users, companys, lobs, positions, leaveTypes)
      set(tempState, 'compensateInbox', compensateRequests)
      set(tempState, 'pendingCompensateInbox', compensateRequests.filter((element) => element.status === 'PENDING'))
      const projectRequests = createArrayOfProjectSubmitRequest(
        projectSubmitRequest, users, companys, lobs, positions, clients, departments)
      set(tempState, 'projectSubmitInbox', projectRequests)
      set(tempState, 'pendingProjectSubmitInbox', projectRequests.filter((element) => element.status === 'PENDING'))
      const timesheetRequests = createArrayOfTimesheetRequest(
        timesheetRequest, users, lobs, positions)
      set(tempState, 'timesheetInbox', timesheetRequests)
      set(tempState, 'pendingTimesheetInbox', timesheetRequests.filter((element) => element.status === 'PENDING' && element.approver_status === 'PENDING'))
      nextProps.resetGetLeaveRequest()
    }
    if (get(nextProps, 'approveLeaveRequestData')) {
      const access_token = localStorage.getItem('access_token')
      nextProps.getAuth(access_token)
      nextProps.getLeaveRequest(access_token)
      nextProps.resetApproveLeaveRequest()
    }
    if (get(nextProps, 'approveCompensateRequestData')) {
      const access_token = localStorage.getItem('access_token')
      nextProps.getAuth(access_token)
      nextProps.getLeaveRequest(access_token)
      nextProps.resetApproveCompensateRequest()
    }
    return tempState
  }

  constructor(props) {
    super(props)
    this.state = {
      search: '',
      showLeave: false,
      showCompensate: false,
      showProject: false,
      showTimesheet: false,
      inboxID: '',
      projectID: '',
      remark: '',
      showRequestDetail: false,
      showCompensateRequestDetail: false,
      activeTab: '1',
      defaultInbox: [],
      inbox: [],
      compensate: [],
      pendingInbox: [],
      companys: [],
      lobs: [],
      departments: [],
      positions: [],
      users: [],
      leaveTypes: [],
      clients: [],
      approverUsers: [],
      projects: [],
      type: '',
      leave_type: '',
      myInbox: [],
      myPendingInbox: [],
      compensateInbox: [],
      pendingCompensateInbox: [],
      projectSubmitInbox: [],
      pendingProjectSubmitInbox: [],
      timesheetInbox: [],
      pendingTimesheetInbox: [],
    }
  }

  componentDidMount() {
    const access_token = localStorage.getItem('access_token')
    this.props.getAuth(access_token)
    this.props.getLeaveType(access_token)
    this.props.getLeaveRequest(access_token)
    this.props.getClient(access_token)
    this.props.getDepartment(access_token)
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (JSON.stringify(nextProps) === JSON.stringify(this.props)
    && JSON.stringify(nextState) === JSON.stringify(this.state)) return false
    return true
  }

  handleClickRow = (id, type, leave_type, projectID) => {
    this.setState({
      inboxID: id,
      leave_type,
      projectID,
    })
    if (type === 'Project Information') {
      this.setState({ showProject: !this.state.showProject })
    } else if (type === 'Timesheet Request') {
      this.setState({ showTimesheet: !this.state.showTimesheet })
    } else if (leave_type === 'Compensate Work') {
      this.setState({ showCompensate: !this.state.showCompensate })
    } else {
      this.setState({ showLeave: !this.state.showLeave })
    }
  }

  handleShowConfirm = (isAprrove) => {
    this.props.showConfirm('confirmApproveOrReject', isAprrove ? 'Approve Confirmation' : 'Reject Confirmation', `Are you sure to ${isAprrove ? 'approve' : 'reject'} this request?`)
  }

  handleClickApproveOrReject = (isApprove) => {
    const access_token = localStorage.getItem('access_token')
    if (this.state.leave_type === 'Compensate Work') {
      this.props.approveCompensateRequest(
        this.state.inboxID, { remark: this.state.remark, is_approve: isApprove }, access_token)
    } else {
      this.props.approveLeaveRequest(this.state.inboxID,
        { remark: this.state.remark, is_approve: isApprove }, access_token)
    }
    this.props.hideConfirm('confirmApproveOrReject')
    this.setState({
      showLeave: false,
      showCompensate: false,
      remark: '',
    })
  }

  handleSearch = (e) => {
    if (e === '') {
      this.setState({ inbox: this.state.defaultInbox, search: '' })
    } else this.setState({ search: e })
  }

  toggle = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab })
    }
  }

  selectButton = (type) => {
    if (type === 'button') {
      return (
        <WrapperButton>
          <CustomButton
            color="danger"
            onClick={ () => this.handleShowConfirm(false) }
          >Reject</CustomButton>
          <CustomButton
            color="success"
            onClick={ () => this.handleShowConfirm(true) }
          >Approve</CustomButton>
        </WrapperButton>
      )
    } else if (type === 'Approve Confirmation') {
      return (
        <WrapperButton>
          <CustomButton
            style={ {
              backgroundColor: '#FFFFFF',
              color: 'black',
            } }
            onClick={ () => this.props.hideConfirm('confirmApproveOrReject') }
          >Cancel</CustomButton>
          <CustomButton
            color="success"
            onClick={ () => this.handleClickApproveOrReject(true) }
          >Approve</CustomButton>
        </WrapperButton>
      )
    } else if (type === 'Reject Confirmation') {
      return (
        <WrapperButton>
          <CustomButton
            style={ {
              backgroundColor: '#FFFFFF',
              color: 'black',
            } }
            onClick={ () => this.props.hideConfirm('confirmApproveOrReject') }
          >Cancel</CustomButton>
          <CustomButton
            color="danger"
            onClick={ () => this.handleClickApproveOrReject(false) }
          >Reject</CustomButton>
        </WrapperButton>
      )
    }
    return null
  }

  render() {
    const isFetching = get(this.props, 'getIsFetching')
    || get(this.props, 'getIsFetchingApprove')
    const {
      redirect,
      redirectTimesheet,
      showLeave,
      showCompensate,
      showProject,
      showTimesheet,
      myInbox,
      myPendingInbox,
      compensateInbox,
      pendingCompensateInbox,
      projectSubmitInbox,
      pendingProjectSubmitInbox,
      timesheetInbox,
      pendingTimesheetInbox,
    } = this.state
    if (redirect) {
      return (<Redirect to={ {
        pathname: `/project_information/${this.state.projectID}`,
        state: { header: 'Project Information', canApprove: this.state.can_approve },
      } }
      />)
    } else if (redirectTimesheet) {
      get(this.props, 'history').push('/time_sheet')
      this.props.hideModal('timesheetDetail')
      return (<Redirect to={ {
        pathname: `/time_sheet/approval/${this.state.inboxID}`,
        state: { header: 'Timesheet', canApprove: this.state.can_approve, activeTab: 4 },
      } }
      />)
    }
    const isAuthenticated = get(this.props, 'redirectAuth.isAuthenticated')
      || get(this.props, 'redirectLeaveRequest.isAuthenticated')
      || get(this.props, 'redirectCompensateRequest.isAuthenticated')
    const redirectToLogin = get(this.props, 'redirectAuth.redirect')
      || get(this.props, 'redirectLeaveRequest.redirect')
      || get(this.props, 'redirectCompensateRequest.redirect')
    if (redirectToLogin) {
      localStorage.clear()
      if (isAuthenticated) localStorage.setItem('bad_token', true)
      this.props.resetAuth()
      window.location = '/'
    }

    return (
      /* eslint no-underscore-dangle: 0 */
      <Wrapper fluid>
        <Searchbar
          activeTab={ this.state.activeTab }
          toggle={ this.toggle }
          handleSearch={ this.handleSearch }
        />
        <CustomModalMessage
          hide={ () => this.props.hideConfirm('confirmApproveOrReject') }
          show={ get(this.props, 'confirmType') === 'confirmApproveOrReject' }
          type={ get(this.props, 'confirmStatus') }
          message={ get(this.props, 'confirmMessage') }
          button={ this.selectButton(get(this.props, 'confirmStatus')) }
        />
        { showLeave &&
        <Leave
          open={ showLeave }
          button={ this.selectButton('button') }
          myInbox={ find(myInbox, { _id: this.state.inboxID }) }
          toggle={ () => this.setState({ showLeave: !this.state.showLeave }) }
          handleRemark={ (e) => this.setState({ remark: e.target.value }) }
        />
        }
        { showCompensate &&
        <Compensate
          open={ showCompensate }
          button={ this.selectButton('button') }
          myInbox={ find(compensateInbox, { _id: this.state.inboxID }) }
          toggle={ () => this.setState({ showCompensate: !this.state.showCompensate }) }
          handleRemark={ (e) => this.setState({ remark: e.target.value }) }
        />
        }
        { showProject &&
        <ProjectSubmitRequestDetail
          open={ showProject }
          request={ find(projectSubmitInbox,
            { _id: this.state.inboxID }) }
          toggle={ () => this.setState({ showProject: !this.state.showProject }) }
          viewProject={ (canApprove) => this.setState({ redirect: true, can_approve: canApprove }) }
        />
        }
        { showTimesheet &&
        <TimesheetDetail
          { ...this.state }
          open={ showTimesheet }
          request={ find(timesheetInbox, { _id: this.state.inboxID }) }
          toggle={ () => this.setState({ showTimesheet: !this.state.showTimesheet }) }
          viewTimesheet={ (canApprove) => {
            this.setState({ redirectTimesheet: true, can_approve: canApprove })
          } }
        />
        }
        { isFetching &&
          <Overlay>
            <OverlayWrapper>
              <BeatLoader
                css={ css(`
                  position: absolute;
                  left: 50%;
                  top: 50%;
                `) }
                sizeUnit={ "px" }
                size={ 15 }
                color={ '#D44B49' }
                loading={ isFetching }
              />
            </OverlayWrapper>
          </Overlay>
        }
        <TabContent activeTab={ this.state.activeTab }>
          { this.state.activeTab === '1' &&
          <TabPane tabId="1">
            <Row noGutters>
              <Col>
                <InboxTable
                  handleClickRow={ this.handleClickRow }
                  myInbox={ [
                    ...myPendingInbox,
                    ...pendingProjectSubmitInbox,
                    ...pendingCompensateInbox,
                    ...pendingTimesheetInbox,
                  ].filter(searchRequestInbox, this.state.search) }
                />
              </Col>
            </Row>
          </TabPane>
          }
          { this.state.activeTab === '2' &&
          <TabPane tabId="2">
            <Row noGutters>
              <Col>
                <InboxTable
                  handleClickRow={ this.handleClickRow }
                  myInbox={ [
                    ...myInbox,
                    ...projectSubmitInbox,
                    ...compensateInbox,
                    ...timesheetInbox,
                  ].filter(searchRequestInbox, this.state.search) }
                />
              </Col>
            </Row>
          </TabPane>
          }
        </TabContent>
      </Wrapper>
    )
  }
}
InboxPage.propTypes = {
  resetAuth: PropTypes.func.isRequired,
  showConfirm: PropTypes.func.isRequired,
  hideConfirm: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
  getAuth: PropTypes.func.isRequired,
  getLeaveType: PropTypes.func.isRequired,
  getLeaveRequest: PropTypes.func.isRequired,
  getClient: PropTypes.func.isRequired,
  getDepartment: PropTypes.func.isRequired,
  approveCompensateRequest: PropTypes.func.isRequired,
  approveLeaveRequest: PropTypes.func.isRequired,
}
const mapStateToProps = (state, props) => createStructuredSelector({
  confirmStatus: modalSelector.confirmStatus,
  confirmType: modalSelector.confirmType,
  confirmMessage: modalSelector.confirmMessage,
  authData: authSelector.getAuth,
  redirectAuth: authSelector.redirectAuth,
  redirectLeaveRequest: leaveRequestSelector.redirectLeaveRequest,
  redirectCompensateRequest: compensateRequestSelector.redirectCompensateRequest,
  getIsFetching: leaveRequestSelector.getIsFetching,
  getIsFetchingApprove: compensateRequestSelector.getIsFetchingApprove,
  getLeaveTypeData: leaveTypeSelector.getLeaveTypeData,
  getLeaveRequestsData: leaveRequestSelector.getMyLeaveRequests,
  approveLeaveRequestData: leaveRequestSelector.approveLeaveRequestData,
  approveCompensateRequestData: compensateRequestSelector.approveCompensateRequestData,
  getClientData: clientMasterSelector.getClientData,
  getDepartmentData: departmentSelector.getListDepartment,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  showModal: modalAction.showModal,
  hideModal: modalAction.hideModal,
  showConfirm: modalAction.showConfirm,
  hideConfirm: modalAction.hideConfirm,
  getAuth: authAction.auth,
  resetAuth: authAction.resetAuthUser,
  getLeaveType: leaveTypeAction.getLeaveType,
  getLeaveRequest: leaveRequestAction.getLeaveRequest,
  resetGetLeaveRequest: leaveRequestAction.resetGetLeaveRequest,
  approveLeaveRequest: leaveRequestAction.approveLeaveRequest,
  resetApproveLeaveRequest: leaveRequestAction.resetApproveLeaveRequest,
  approveCompensateRequest: compensateRequestAction.approveCompensateRequest,
  resetApproveCompensateRequest: compensateRequestAction.resetApproveCompensateRequest,
  getClient: clientMasterAction.getClient,
  getDepartment: departmentAction.getDepartment,
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(withLayout(InboxPage))

const WrapperButton = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`
const Wrapper = styled(Container)`
  padding: 0px;
  background-color: #F1F1F1;
`
const CustomButton = styled(Button)`
  margin-left: 10px;
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.NORMAL_SIZE};
`
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
`
const OverlayWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`



// WEBPACK FOOTER //
// ./src/pages/inbox/index.js